import request from 'utils/request';

export function fetchSurveySummary(params, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  };

  return request(`/api/v3/survey/${params.id}/summary`, requestOptions);
}

export function downloadFile(surveyId, url, options = {}) {
  const { canSplitMatrixQuestions = false } = options;
  const requestOptions = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    includeHeaders: true,
    includeBlob: true,
    includeStatus: true,
  };
  let requestUrl = `${url}?id=${surveyId}`;
  if (canSplitMatrixQuestions) {
    requestUrl += `&splitMatrixQuestions=${canSplitMatrixQuestions}`;
  }

  return request(requestUrl, requestOptions);
}
